import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'timeRemaining', pure: false })

export class TimeRemainingPipe implements PipeTransform {

	constructor(private translateService: TranslateService) {
	}

	transform(resumeDate: any): string {
		if (!resumeDate) {
			return '';
		}

		let hoursRemaining: number;
		let minutesRemaining: number;
		const currentTime = new Date();
		const currentHour = currentTime.getUTCHours();
		const currentMinute = currentTime.getUTCMinutes();
		const resumeDateFormat = new Date(resumeDate);
		const resumeDateHour = resumeDateFormat.getUTCHours();
		const resumeDateMinute = resumeDateFormat.getUTCMinutes();

		if (resumeDateHour > currentHour) {
			hoursRemaining = (1 - (resumeDateHour - currentHour));
		} else {
			hoursRemaining = (23 - (currentHour - resumeDateHour));
		}

		if (resumeDateMinute >= currentMinute) {
			minutesRemaining = resumeDateMinute - currentMinute;
		} else {
			minutesRemaining = (60 - (currentMinute - resumeDateMinute));
		}
		const quotumReachedMessage = this.translateService.instant('CHANNEL_QUOTA_EXCEEDED', {
			x: hoursRemaining,
			y: minutesRemaining
		});

		return quotumReachedMessage;
	}
}
